import { render, staticRenderFns } from "./SelectCurrency.vue?vue&type=template&id=3da3b244&scoped=true"
import script from "./SelectCurrency.vue?vue&type=script&lang=js"
export * from "./SelectCurrency.vue?vue&type=script&lang=js"
import style0 from "./SelectCurrency.vue?vue&type=style&index=0&id=3da3b244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da3b244",
  null
  
)

export default component.exports